(function () {
  var SELECTOR = '[data-samsung-landing]';
  var READY_ATTR = 'data-samsung-landing-ready';
  var CAMPAIGN = 'bespoke-benefits';
  var ROLE_REDEMPTION = 'redemption';
  var STRINGS = {
    empty: 'Vul je Samsung-code in.',
    invalid: 'Deze code is niet geldig of kan niet meer worden gebruikt.',
    unavailable: 'Dit product is tijdelijk niet beschikbaar.',
    network: 'Er ging iets mis. Probeer het opnieuw.',
    busyRedeem: 'Code wordt toegevoegd.',
    busyRemove: 'Item wordt verwijderd.',
    busyAdd: 'Product wordt toegevoegd.',
    added: 'Toegevoegd aan je winkelmandje.',
    removed: 'Verwijderd uit je winkelmandje.',
  };

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (path.charAt(0) === '/') path = path.slice(1);
    return root + path;
  }

  function cartRoutes() {
    return {
      add: (window.routes && window.routes.cart_add_url) || rootUrl('cart/add.js'),
      change: (window.routes && window.routes.cart_change_url) || rootUrl('cart/change.js'),
      update: (window.routes && window.routes.cart_update_url) || rootUrl('cart/update.js'),
      get: rootUrl('cart.js'),
    };
  }

  function sectionPayload() {
    return {
      sections: 'cart-icon-bubble',
      sections_url: window.location.pathname,
    };
  }

  function parseJson(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function isErrorPayload(json) {
    if (!json || typeof json !== 'object') return false;
    if (json.errors) return true;
    if (typeof json.status === 'number' && json.status >= 400) return true;
    if (json.message === 'Cart Error') return true;
    return false;
  }

  function errorMessageFrom(json, fallback) {
    if (!json) return fallback;
    if (typeof json.description === 'string' && json.description) return STRINGS.invalid;
    if (typeof json.message === 'string' && json.message && json.message !== 'Cart Error') {
      return STRINGS.network;
    }
    if (typeof json.errors === 'string' && json.errors) return STRINGS.network;
    return fallback;
  }

  async function requestJson(url, options) {
    var response = await fetch(url, options);
    var text = await response.text();
    var json = parseJson(text);
    if (!response.ok || isErrorPayload(json)) {
      var error = new Error(errorMessageFrom(json, STRINGS.network));
      error.status = response.status;
      error.payload = json;
      throw error;
    }
    return json;
  }

  async function postCart(url, payload) {
    var body = Object.assign({}, payload, sectionPayload());
    try {
      return await requestJson(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      });
    } catch (error) {
      if (error.status === 400 && body.sections) {
        return requestJson(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });
      }
      throw error;
    }
  }

  function getCart() {
    return requestJson(cartRoutes().get, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
  }

  function itemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isCampaignItem(item, role) {
    var properties = itemProperties(item);
    if (properties._samsung_campaign !== CAMPAIGN) return false;
    if (role && properties._samsung_role !== role) return false;
    return true;
  }

  function findCampaignItem(cart, role) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      if (isCampaignItem(items[i], role)) return items[i];
    }
    return null;
  }

  function applicableDiscountCodes(cart) {
    var codes = [];
    var list = cart && cart.discount_codes;
    if (!Array.isArray(list)) return codes;
    for (var i = 0; i < list.length; i++) {
      var entry = list[i];
      if (entry && entry.applicable && entry.code) codes.push(String(entry.code));
    }
    return codes;
  }

  function discountString(codes, extraCode, omitCode) {
    var next = [];
    var seen = {};
    function add(code) {
      if (!code) return;
      var key = String(code).toLowerCase();
      if (omitCode && key === String(omitCode).toLowerCase()) return;
      if (seen[key]) return;
      seen[key] = true;
      next.push(code);
    }
    (codes || []).forEach(add);
    add(extraCode);
    return next.join(',');
  }

  function isCodeApplicable(cart, code) {
    var list = cart && cart.discount_codes;
    if (!Array.isArray(list)) return null;
    var needle = String(code).toLowerCase();
    for (var i = 0; i < list.length; i++) {
      var entry = list[i];
      if (entry && String(entry.code || '').toLowerCase() === needle) {
        return entry.applicable === true;
      }
    }
    return false;
  }

  function isLineFullyDiscounted(item) {
    if (!item) return false;
    var original = Number(item.original_line_price);
    var finalLine = Number(item.final_line_price);
    if (!(original > 0) || finalLine !== 0) return false;
    if (Number(item.quantity) !== 1) return false;
    return true;
  }

  function isSuccessfulRedemption(cart, code, variantId) {
    var item = findCampaignItem(cart, ROLE_REDEMPTION);
    if (!item) return false;
    if (variantId && Number(item.variant_id) !== Number(variantId)) return false;
    if (!isLineFullyDiscounted(item)) return false;
    if (code) {
      var applicable = isCodeApplicable(cart, code);
      if (applicable === false) return false;
    }
    return true;
  }

  function patchCartIconBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var source = doc.querySelector('.shopify-section') || doc.body;
    if (source) bubble.innerHTML = source.innerHTML;
  }

  function notifyCart(cart) {
    if (cart && cart.sections) patchCartIconBubble(cart.sections);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'samsung-landing', cartData: cart });
    }
  }

  function campaignProperties(role, code) {
    var properties = {
      _samsung_campaign: CAMPAIGN,
      _samsung_role: role,
    };
    if (code) properties._samsung_code = code;
    return properties;
  }

  function addCampaignItem(variantId, role, code) {
    return postCart(cartRoutes().add, {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: campaignProperties(role, code),
        },
      ],
    }).then(function (result) {
      notifyCart(result);
      return getCart().then(function (cart) {
        notifyCart(cart);
        return cart;
      });
    });
  }

  function changeLine(key, quantity) {
    return postCart(cartRoutes().change, {
      id: key,
      quantity: quantity,
    }).then(function (cart) {
      notifyCart(cart);
      return cart.items ? cart : getCart();
    });
  }

  function updateDiscounts(codes, extraCode, omitCode) {
    return postCart(cartRoutes().update, {
      discount: discountString(codes, extraCode, omitCode),
    }).then(function (cart) {
      notifyCart(cart);
      return cart.items ? cart : getCart();
    });
  }

  async function removeCampaignRole(cart, role) {
    var current = cart;
    var item = findCampaignItem(current, role);
    while (item && item.key) {
      current = await changeLine(item.key, 0);
      if (!current.items) current = await getCart();
      item = findCampaignItem(current, role);
    }
    return current;
  }

  function parseConfig(root) {
    var node = root.querySelector('[data-samsung-config]');
    if (!node) return {};
    return parseJson(node.textContent) || {};
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
    }
  }

  function setBusy(el, busy) {
    if (!el) return;
    if (busy) {
      el.setAttribute('aria-busy', 'true');
      el.disabled = true;
    } else {
      el.removeAttribute('aria-busy');
      el.disabled = false;
    }
  }

  function init(root) {
    if (!root || root.getAttribute(READY_ATTR) === 'true') return;
    root.setAttribute(READY_ATTR, 'true');

    var config = parseConfig(root);
    var form = root.querySelector('[data-samsung-code-form]');
    var input = root.querySelector('[data-samsung-code-input]');
    var redeemButton = root.querySelector('[data-samsung-redeem]');
    var redeemSuccess = root.querySelector('[data-samsung-redeem-success]');
    var redeemRemove = root.querySelector('[data-samsung-redeem-remove]');
    var errorNode = root.querySelector('#samsung-code-error');
    var liveNode = root.querySelector('[data-samsung-live]');
    var queue = Promise.resolve();
    var locked = false;

    function announce(message) {
      if (liveNode) liveNode.textContent = message || '';
    }

    function setCodeError(message) {
      if (!errorNode) return;
      if (message) {
        errorNode.textContent = message;
        setHidden(errorNode, false);
        if (input) input.setAttribute('aria-invalid', 'true');
      } else {
        errorNode.textContent = '';
        setHidden(errorNode, true);
        if (input) input.removeAttribute('aria-invalid');
      }
    }

    function setInputFilled() {
      if (!input) return;
      if (input.value) {
        input.setAttribute('data-filled', 'true');
      } else {
        input.removeAttribute('data-filled');
      }
    }

    function setRedeemUi(success) {
      if (form) form.classList.toggle('is-success', success);
      setHidden(input, success);
      setHidden(redeemButton, success);
      setHidden(redeemSuccess, !success);
      setHidden(redeemRemove, !success);
      if (input) {
        input.readOnly = false;
        if (success) input.setAttribute('data-filled', 'true');
      }
    }

    function setCardUi(card, added) {
      if (!card) return;
      card.classList.toggle('is-added', added);
      setHidden(card.querySelector('[data-samsung-add]'), added);
      setHidden(card.querySelector('[data-samsung-price]'), added);
      setHidden(card.querySelector('[data-samsung-added]'), !added);
      setHidden(card.querySelector('[data-samsung-remove]'), !added);
    }

    function syncUi(cart) {
      var cards = root.querySelectorAll('[data-samsung-card]');
      for (var i = 0; i < cards.length; i++) {
        var role = cards[i].getAttribute('data-samsung-role');
        setCardUi(cards[i], Boolean(findCampaignItem(cart, role)));
      }

      var redemption = findCampaignItem(cart, ROLE_REDEMPTION);
      var storedCode = redemption ? itemProperties(redemption)._samsung_code : '';
      if (storedCode && input && !input.value) {
        input.value = storedCode;
        setInputFilled();
      }

      var success = isSuccessfulRedemption(
        cart,
        storedCode || (input && input.value),
        config.blueberryVariantId
      );
      setRedeemUi(success);
      if (!success) {
        if (input && !input.value) setInputFilled();
      }
    }

    function enqueue(task) {
      queue = queue.then(task, task);
      return queue;
    }

    async function withLock(task) {
      if (locked) return;
      locked = true;
      root.classList.add('is-busy');
      try {
        await task();
      } finally {
        locked = false;
        root.classList.remove('is-busy');
        setBusy(redeemButton, false);
        if (config.blueberryAvailable === false || !config.blueberryVariantId) {
          if (redeemButton) redeemButton.disabled = true;
        }
        setBusy(redeemRemove, false);
        var buttons = root.querySelectorAll('[data-samsung-add], [data-samsung-remove]');
        for (var i = 0; i < buttons.length; i++) setBusy(buttons[i], false);
      }
    }

    async function ensureCart() {
      return getCart();
    }

    async function cleanupFailedRedemption(cart, previousCodes, attemptedCode) {
      var current = cart;
      try {
        current = await updateDiscounts(previousCodes, null, attemptedCode);
      } catch (error) {
        current = await getCart();
      }
      current = await removeCampaignRole(current, ROLE_REDEMPTION);
      return current;
    }

    async function redeemCode() {
      try {
        setCodeError('');
        var code = input ? String(input.value || '').trim() : '';
        if (input) input.value = code;
        setInputFilled();

        if (!code) {
          setCodeError(STRINGS.empty);
          if (input) input.focus();
          return;
        }

        if (!config.blueberryVariantId || config.blueberryAvailable === false) {
          setCodeError(STRINGS.unavailable);
          return;
        }

        setBusy(redeemButton, true);
        announce(STRINGS.busyRedeem);

        var cart = await ensureCart();
        var previousCodes = applicableDiscountCodes(cart);
        var existing = findCampaignItem(cart, ROLE_REDEMPTION);

        if (existing && !isSuccessfulRedemption(cart, itemProperties(existing)._samsung_code || code, config.blueberryVariantId)) {
          cart = await removeCampaignRole(cart, ROLE_REDEMPTION);
          existing = findCampaignItem(cart, ROLE_REDEMPTION);
        }

        if (isSuccessfulRedemption(cart, itemProperties(existing)._samsung_code || code, config.blueberryVariantId)) {
          syncUi(cart);
          return;
        }

        if (!existing) {
          try {
            cart = await addCampaignItem(config.blueberryVariantId, ROLE_REDEMPTION, code);
          } catch (error) {
            setCodeError(STRINGS.unavailable);
            announce(STRINGS.unavailable);
            return;
          }
        }

        try {
          cart = await updateDiscounts(previousCodes, code);
        } catch (error) {
          cart = await cleanupFailedRedemption(await getCart(), previousCodes, code);
          syncUi(cart);
          setRedeemUi(false);
          setCodeError(STRINGS.invalid);
          announce(STRINGS.invalid);
          return;
        }

        if (!isSuccessfulRedemption(cart, code, config.blueberryVariantId)) {
          cart = await cleanupFailedRedemption(cart, previousCodes, code);
          syncUi(cart);
          setRedeemUi(false);
          setCodeError(STRINGS.invalid);
          announce(STRINGS.invalid);
          return;
        }

        syncUi(cart);
        setRedeemUi(true);
        setCodeError('');
        announce(STRINGS.added);
      } catch (error) {
        setCodeError(STRINGS.network);
        announce(STRINGS.network);
      }
    }

    async function removeRedemption() {
      setBusy(redeemRemove, true);
      announce(STRINGS.busyRemove);
      try {
        var cart = await ensureCart();
        var redemption = findCampaignItem(cart, ROLE_REDEMPTION);
        var attemptedCode = redemption ? itemProperties(redemption)._samsung_code : input && input.value;
        var previousCodes = applicableDiscountCodes(cart);
        cart = await updateDiscounts(previousCodes, null, attemptedCode);
        cart = await removeCampaignRole(cart, ROLE_REDEMPTION);
        syncUi(cart);
        setRedeemUi(false);
        setCodeError('');
        announce(STRINGS.removed);
      } catch (error) {
        announce(STRINGS.network);
      }
    }

    async function addUpsell(card) {
      var role = card.getAttribute('data-samsung-role');
      var variantId = card.getAttribute('data-samsung-variant-id');
      var addButton = card.querySelector('[data-samsung-add]');
      if (!role || !variantId) {
        announce(STRINGS.unavailable);
        return;
      }
      setBusy(addButton, true);
      announce(STRINGS.busyAdd);
      try {
        var cart = await ensureCart();
        if (findCampaignItem(cart, role)) {
          syncUi(cart);
          return;
        }
        cart = await addCampaignItem(variantId, role);
        syncUi(cart);
        announce(STRINGS.added);
      } catch (error) {
        announce(STRINGS.network);
      }
    }

    async function removeUpsell(card) {
      var role = card.getAttribute('data-samsung-role');
      var removeButton = card.querySelector('[data-samsung-remove]');
      setBusy(removeButton, true);
      announce(STRINGS.busyRemove);
      try {
        var cart = await ensureCart();
        cart = await removeCampaignRole(cart, role);
        syncUi(cart);
        announce(STRINGS.removed);
      } catch (error) {
        announce(STRINGS.network);
      }
    }

    if (input) {
      input.addEventListener('input', function () {
        setInputFilled();
        if (input.getAttribute('aria-invalid') === 'true') setCodeError('');
      });
      setInputFilled();
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        enqueue(function () {
          return withLock(redeemCode);
        });
      });
    }

    if (redeemRemove) {
      redeemRemove.addEventListener('click', function () {
        enqueue(function () {
          return withLock(removeRedemption);
        });
      });
    }

    root.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-samsung-add]');
      var removeButton = event.target.closest('[data-samsung-remove]');
      if (addButton) {
        event.preventDefault();
        var addCard = addButton.closest('[data-samsung-card]');
        if (!addCard) return;
        enqueue(function () {
          return withLock(function () {
            return addUpsell(addCard);
          });
        });
        return;
      }
      if (removeButton && removeButton.hasAttribute('data-samsung-redeem-remove')) return;
      if (removeButton) {
        event.preventDefault();
        var removeCard = removeButton.closest('[data-samsung-card]');
        if (!removeCard) return;
        enqueue(function () {
          return withLock(function () {
            return removeUpsell(removeCard);
          });
        });
      }
    });

    enqueue(function () {
      return getCart()
        .then(function (cart) {
          var redemption = findCampaignItem(cart, ROLE_REDEMPTION);
          if (redemption && !isSuccessfulRedemption(cart, itemProperties(redemption)._samsung_code, config.blueberryVariantId)) {
            return cleanupFailedRedemption(cart, applicableDiscountCodes(cart), itemProperties(redemption)._samsung_code).then(syncUi);
          }
          syncUi(cart);
        })
        .catch(function () {
          announce(STRINGS.network);
        });
    });

    if (redeemButton && (config.blueberryAvailable === false || !config.blueberryVariantId)) {
      redeemButton.disabled = true;
    }

    initReviewsSlider(root);
  }

  function initReviewsSlider(root) {
    var rail = root.querySelector('[data-samsung-reviews]');
    if (!rail || rail.getAttribute('data-samsung-slider') === 'true') return;
    rail.setAttribute('data-samsung-slider', 'true');

    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var dragging = false;
    var inertiaId = 0;
    var DRAG_THRESHOLD = 3;

    function stopInertia() {
      if (!inertiaId) return;
      cancelAnimationFrame(inertiaId);
      inertiaId = 0;
    }

    function maxScroll() {
      return Math.max(0, rail.scrollWidth - rail.clientWidth);
    }

    function clampScroll(value) {
      return Math.max(0, Math.min(maxScroll(), value));
    }

    function cardStep() {
      var card = rail.querySelector('.samsung-landing__review');
      if (!card) return 0;
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function snapToNearest() {
      var step = cardStep();
      if (step <= 0) return;
      var target = Math.round(rail.scrollLeft / step) * step;
      if (typeof rail.scrollTo === 'function') {
        rail.scrollTo({ left: clampScroll(target), behavior: 'smooth' });
      } else {
        rail.scrollLeft = clampScroll(target);
      }
    }

    function runInertia(startVelocity) {
      var vx = startVelocity;
      var previous = performance.now();

      function tick(now) {
        var dt = Math.min(32, now - previous);
        previous = now;
        vx *= Math.pow(0.92, dt / 16);
        rail.scrollLeft = clampScroll(rail.scrollLeft - vx * dt);
        if (Math.abs(vx) > 0.04) {
          inertiaId = requestAnimationFrame(tick);
          return;
        }
        inertiaId = 0;
        snapToNearest();
      }

      inertiaId = requestAnimationFrame(tick);
    }

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('a, button, input, textarea, select, label')) return;
      stopInertia();
      pointerId = event.pointerId;
      startX = lastX = event.clientX;
      startScroll = rail.scrollLeft;
      lastTime = performance.now();
      velocity = 0;
      dragging = false;
      rail.classList.add('is-dragging');
      rail.style.scrollSnapType = 'none';
      try {
        rail.setPointerCapture(pointerId);
      } catch (error) {
        /* Capture is optional; mouse move still tracks while pressed. */
      }
    });

    rail.addEventListener(
      'pointermove',
      function (event) {
        if (pointerId === null || event.pointerId !== pointerId) return;
        var now = performance.now();
        var delta = event.clientX - startX;
        if (!dragging && Math.abs(delta) > DRAG_THRESHOLD) {
          dragging = true;
        }
        if (!dragging) return;
        event.preventDefault();
        var dt = Math.max(1, now - lastTime);
        velocity = (event.clientX - lastX) / dt;
        lastX = event.clientX;
        lastTime = now;
        rail.scrollLeft = clampScroll(startScroll - delta);
      },
      { passive: false }
    );

    function endDrag(event) {
      if (pointerId === null || (event && event.pointerId !== pointerId)) return;
      var wasDragging = dragging;
      pointerId = null;
      dragging = false;
      rail.classList.remove('is-dragging');
      rail.style.scrollSnapType = '';
      if (!wasDragging) return;
      if (Math.abs(velocity) > 0.12) {
        runInertia(velocity);
      } else {
        snapToNearest();
      }
    }

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener(
      'wheel',
      function () {
        stopInertia();
      },
      { passive: true }
    );
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var nodes = context.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      init(nodes[i]);
    }

    if (context.matches && context.matches(SELECTOR)) {
      init(context);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
